import { Fancybox } from "@fancyapps/ui/dist/fancybox";

window.addEventListener(`DOMContentLoaded`, () => {

  Fancybox.bind("[data-fancybox]", {
    groupAll: false, // Group all items
    Thumbs: false,
    groupAttr: false,
    Carousel: {
      Thumbs: false,
      Toolbar: {
        display: {
          left: [],
          middle: [],
          right: ["close"],
        },
      },
    },
  });

  const images = document.querySelectorAll('.info-content__content img');
  if (images) {
    images.forEach((img) => {
      const link = document.createElement('a');
      link.href = img.src;
      link.setAttribute('data-fancybox', '');
      img.parentNode.insertBefore(link, img);
      link.appendChild(img);
    });
  }

});